import { Button, Text } from 'native-base'

import { colors } from '../../utils/theme/configureTheme'

interface SubmitButtonProps {
  onPress: () => void
  isLoading: boolean
  isDisabled: boolean
}

/** Submit button for the report issue form with loading and disabled states. */
export default function SubmitButton({ onPress, isLoading, isDisabled }: SubmitButtonProps) {
  return (
    <Button
      onPress={onPress}
      isLoading={isLoading}
      isDisabled={isDisabled}
      variant="solid"
      borderRadius={100}
      bgColor={colors.brand.vermillion}
      width="100%"
      py={3}
      _disabled={{
        opacity: 0.5,
      }}
    >
      <Text fontSize={16} fontWeight={600} color={colors.brand.white}>
        Submit
      </Text>
    </Button>
  )
}
